import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ComboService, JobWorkService } from "../../../services/index";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
// import { ocrDcPrint } from "./ocrDcPrint";

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./jobocr_dc.html",
})
export class jobocrDc implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  designnoList = [];
  gridOptions: any;
  dataList = [];
  selected = [];
  data = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  dcStatusList = ["Yes", "No"];
  filter = {
    rgrn_no: "",
    shirt_design_no: "",
    from_date: "",
    dc_status: "No",
    to_date: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "r.rgrn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private JobWorkService: JobWorkService,
    public toasterService: ToasterService,
    private comboservice: ComboService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.getDesignNoList();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    if (
      this.filter.dc_status == "No"
    ) {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Ref No",
          prop: "ref_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Date",
          prop: "date",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "WO.Del No",
          prop: "rgrn_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "F.Tot",
          prop: "ftot",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
        {
          name: "H.Tot",
          prop: "htot",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
        {
          name: "Tot.Qty",
          prop: "tot",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
      ];
    } else {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "DC Date",
          prop: "dc_date",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "No.Of Wos",
          prop: "count",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
        {
          name: "F.Tot",
          prop: "ftot",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
        {
          name: "H.Tot",
          prop: "htot",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
        {
          name: "Tot.Qty",
          prop: "tot",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 70,
        },
        // {
        //   name: "DC Print",
        //   prop: "dcprint",
        //   minWidth: 150,
        //   maxWidth: 150,
        //   width: 150,
        //   cellClass: "text-center",
        //   sortable: false,
        //   cellTemplate: this.detailsTemplate,
        // },
      ];
    }
    if (this.filter.dc_status == "No") {
      let select = {
        prop: "selected",
        name: "",
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: false,
        checkboxable: true,
        width: 30,
      };
      this.columns.splice(0, 0, select);
    } else {
      let column = this.columns.filter(function (obj) {
        return obj.prop !== "selected";
      });
      this.columns = column;
    }
    if (this.filter.dc_status == "Yes") {
      let dc_no = {
        name: "DC.NO",
        prop: "dc_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      };

      this.columns.splice(1, 0, dc_no);
    } else {
      let column = this.columns.filter(function (obj) {
        return obj.prop !== "dc_no";
      });
      this.columns = column;
    }
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }
  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  clearFilter(): void {
    this.filter.from_date = "";
    this.filter.to_date = "";
    this.filter.rgrn_no = "";
    this.filter.shirt_design_no = "";
    this.filter.dc_status = "No";
    this.applyFilter();
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.getColumns();
    this.getOrderList();
  }

  onSelect({ selected }) {
    this.selected = [];
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  getOrderList(): void {
    if (this.filter.from_date) {
      this.filter.from_date = this.datePipe.transform(
        this.filter.from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.to_date) {
      this.filter.to_date = this.datePipe.transform(
        this.filter.to_date,
        "yyyy-MM-dd"
      );
    }

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
      shirt_design_no: this.filter.shirt_design_no,
      dc_status: this.filter.dc_status,
      rgrn_no: this.filter.rgrn_no,
    };
    let that = this;
    this.isLoadMask = this.JobWorkService
      .getjobOCRDcList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
  onSubmitMergeDC() {
    if (this.selected.length > 0) {
      let obj = {
        wo_id: "",
        dc_status:"",
      };
      this.selected.forEach((el) => {
        obj = {
          wo_id: el.wo_id,
          dc_status: "Yes",
        };
        this.data.push(obj);
      });
      this.approveDc();
    } else {
      swal("Select Atleast One CU.NO");
    }
  }
  approveDc() {
    let that = this;
    swal({
      title: "Are you sure to Approve these DC.NO?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    }).then(
      function () {
        let params = {
          selectedList: JSON.stringify(that.data),
        };
          that.isLoadMask = that.JobWorkService
            .approvejobocrDc(params)
            .then((res: any) => {
              if (res.success) {
                swal(
                  "DC Approved Successfully and DC No " +
                    res.dc_no +
                    " was generated"
                );
                that.data = [];
              }
              if (res.success) {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };

                  that.tabUpdateEvent.emit(tabObj);
                }
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
            });
      },
      function (dismiss) {}
    );
  }
  deleteOrder(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this OCR DC Entry details?",
      text: "You will not be able to recover this" + " " + row["cu_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.JobWorkService
          .deleteWoDel(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
  bsModalRef: BsModalRef;
  // print(row) {
  //   this.bsModalRef = this.modalService.show(ocrDcPrint, {
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: "modal-lg compWidth-96",
  //   });
  //   this.bsModalRef.content.printdt = Object.assign({}, row);
  // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/jobocr_dc.ts